import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NavigationItemEntity } from '@/app/platform/platform-data/models/navigation-item.entity';
import { NavigationItemNode } from '@/app/platform/platform-shared/navigation-item-tree/navigation-item-dragger';
import { PageFeature } from '@ervo/page-framework';

@Component({
    selector: 'feature-access-toggler',
    templateUrl: './feature-access-toggler.component.html',
    styleUrls: ['./feature-access-toggler.component.scss'],
    standalone: false
})
export class FeatureAccessTogglerComponent implements OnInit {
  @Input() feature: PageFeature;
  @Input() isAuthorized: boolean;
  @Input() node: NavigationItemNode<any>;

  @Output() toggleFeature = new EventEmitter<[PageFeature, NavigationItemEntity]>();

  constructor() {}

  ngOnInit(): void {}

  onToggleFeature(feature: PageFeature, item: NavigationItemEntity): void {
    this.toggleFeature.emit([feature, item]);
  }
}
